<template lang='pug'>
div
  strong {{ conceptsToString }}
</template>

<script>
export default {
  data() { return {
      config: [
        'prueba',
        'cuestiones-previas-y-procesales',
        'circunstancias-modificativas-de-la-responsabilidad'
      ]
    }
  },
  props: {
    mineConcepts: { type: Array, default: () => [] },
    descriptores: { type: Object, default: () => {} },
  },
  computed: {
    concepts() {
      let result = this.config.map(row => this.extractConcepts(row))
      result.unshift(this.extractConcepts(this.mainRow))
      return result
    },
    conceptsToString() {
      if (!this.mineConcepts.length) return ''

      const permittedConcepts = 3
      return this.concepts.flat().slice(0, permittedConcepts)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).replace(/-/g, ' '))
        .join(' | ')
    }
  },
  methods: {
    extractConcepts(typeV) {
      let res = (this.mineConcepts || []).filter(concept => concept.r === typeV)
      return res.sort((a, b) => b.s - a.s).map(c => c.v)
    },
    mainRow() {
      const penalId = 6
      if (this.descriptores['jurisdiccion'] === penalId) {
        return 'tipos-de-delito'
      } else {
        return 'objeto-del-procedimiento'
      }
    }
  }
}
</script>
